export default __webpack_public_path__ + "static/media/water.398c81ed.png";